import React, { useState, useEffect } from 'react';
import { Grid, Tabs, Tab, TablePagination } from '@mui/material';
import axios from 'axios';
import EventPostDetailsCard from './EventPostDetailsCard';
import NoAvailableData from 'reuseableTable/NoAvailableData';
import AnimatedLoader from 'reuseableTable/AnimatedLoader';
import JoinedEvents from 'views/joinedEvents';
import useRequestIdGenerater from 'customhooks';
import useTimeStamp from 'reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp';

const UpcomingEvents = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [eventDetails, setEventDetails] = useState([]);
  const [pageCache, setPageCache] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [totalCount, setTotalCount] = useState(0);

  const [clickedDetails, setClickedDetails] = useState(false);
  const [postId, setPostId] = useState("");
  const [eventType, setEventType] = useState("Upcoming");

  const RequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();

  const handleClickedDetails = (id) => {
    setPostId(id);
    setClickedDetails(true);
  };

  const handleCloseDetails = () => {
    setClickedDetails(false);
  };

  const getEventDetails = async (eventType) => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `/v1/event/my?pageSize=${rowsPerPage}&pageNumber=${page}&myEventType=${eventType}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );

      setEventDetails(response?.data?.data?.content);
      setTotalCount(response?.data?.data?.totalElements);
      setPageCache((prev) => ({
        ...prev,
        [page]: response?.data?.data?.content,
      }));
      setIsLoading(false);
      generateTimeStamp();
    } catch (error) {
      setIsLoading(false);
      generateTimeStamp();
      console.error("Failed to fetch data:", error);
    }
  };

  useEffect(() => {
    if (pageCache[page]) {
      setEventDetails(pageCache[page]);
    } else {
      getEventDetails(eventType);
    }
  }, [page, rowsPerPage, eventType]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setPageCache({});
  };

  const handleTabChange = (event, newValue) => {
    setEventType(newValue);
    setPage(0);
    setPageCache({});
  };
  const noDataMessage = {
    "Upcoming": "There are no Upcoming Events.",
    "Pending": "You have no Pending Events.",
    "My_Upcoming": "You have no Upcoming Events.",
    "My_All": "There are no Events."
  };

  useEffect(() => {
    generateTimeStamp();
  }, []);

  return (
    <>
      {clickedDetails ? (
        <JoinedEvents handleCloseDetails={handleCloseDetails} type="alumni" postId={postId} />
      ) : (
        <>
          <Tabs value={eventType} onChange={handleTabChange}>
            <Tab label="Upcoming Events" value="Upcoming" />
            <Tab label="Pending Request" value="Pending" />
            <Tab label="My Upcoming Events" value="My_Upcoming" />
            <Tab label="My All Events" value="My_All" />
          </Tabs>

          {isLoading ? (
            <AnimatedLoader />
          ) : (
            eventDetails.length > 0 ? (
              <>
                <Grid container spacing={2} p={2}>
                  {eventDetails.map((post) => (
                    <Grid key={post.id} item xs={12} md={3} lg={3}>
                      <EventPostDetailsCard
                        handleClickedDetails={handleClickedDetails}
                        post={post}
                        eventType={eventType}
                        getEventDetails={getEventDetails}
                      />
                    </Grid>
                  ))}
                </Grid>
                <TablePagination
                  component="div"
                  count={totalCount}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </>
            ) : (
              <NoAvailableData text={noDataMessage[eventType]} />
            )
          )}
        </>
      )}
    </>
  );
};

export default UpcomingEvents;

